export default {
  methods: {
    getImgUrl: function (imgName) {
      return require(`@/assets/${imgName}`);
    }
  }
};
